module.exports = {
  0: {f: 'General'},
  1: {f: '0'},
  2: {f: '0.00'},
  3: {f: '#,##0'},
  4: {f: '#,##0.00'},
  9: {f: '0%'},
  10: {f: '0.00%'},
  11: {f: '0.00E+00'},
  12: {f: '# ?/?'},
  13: {f: '# ??/??'},
  14: {f: 'mm-dd-yy'},
  15: {f: 'd-mmm-yy'},
  16: {f: 'd-mmm'},
  17: {f: 'mmm-yy'},
  18: {f: 'h:mm AM/PM'},
  19: {f: 'h:mm:ss AM/PM'},
  20: {f: 'h:mm'},
  21: {f: 'h:mm:ss'},
  22: {f: 'm/d/yy "h":mm'},

  27: {
    'zh-tw': '[$-404]e/m/d',
    'zh-cn': 'yyyy"å¹´"m"æ"',
    'ja-jp': '[$-411]ge.m.d',
    'ko-kr': 'yyyy"å¹´" mm"æ" dd"æ¥"',
  },
  28: {
    'zh-tw': '[$-404]e"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': '[$-411]ggge"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'mm-dd',
  },
  29: {
    'zh-tw': '[$-404]e"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': '[$-411]ggge"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'mm-dd',
  },
  30: {'zh-tw': 'm/d/yy ', 'zh-cn': 'm-d-yy', 'ja-jp': 'm/d/yy', 'ko-kr': 'mm-dd-yy'},
  31: {
    'zh-tw': 'yyyy"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'yyyy"å¹´"m"æ"d"æ¥"',
    'ja-jp': 'yyyy"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'yyyy"ë" mm"ì" dd"ì¼"',
  },
  32: {
    'zh-tw': 'hh"æ"mm"å"',
    'zh-cn': 'h"æ¶"mm"å"',
    'ja-jp': 'h"æ"mm"å"',
    'ko-kr': 'h"ì" mm"ë¶"',
  },
  33: {
    'zh-tw': 'hh"æ"mm"å"ss"ç§"',
    'zh-cn': 'h"æ¶"mm"å"ss"ç§"',
    'ja-jp': 'h"æ"mm"å"ss"ç§"',
    'ko-kr': 'h"ì" mm"ë¶" ss"ì´"',
  },
  34: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"',
    'zh-cn': 'ä¸å/ä¸å h"æ¶"mm"å"',
    'ja-jp': 'yyyy"å¹´"m"æ"',
    'ko-kr': 'yyyy-mm-dd',
  },
  35: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"ss"ç§"',
    'zh-cn': 'ä¸å/ä¸å h"æ¶"mm"å"ss"ç§"',
    'ja-jp': 'm"æ"d"æ¥"',
    'ko-kr': 'yyyy-mm-dd',
  },
  36: {
    'zh-tw': '[$-404]e/m/d',
    'zh-cn': 'yyyy"å¹´"m"æ"',
    'ja-jp': '[$-411]ge.m.d',
    'ko-kr': 'yyyy"å¹´" mm"æ" dd"æ¥"',
  },

  37: {f: '#,##0 ;(#,##0)'},
  38: {f: '#,##0 ;[Red](#,##0)'},
  39: {f: '#,##0.00 ;(#,##0.00)'},
  40: {f: '#,##0.00 ;[Red](#,##0.00)'},
  45: {f: 'mm:ss'},
  46: {f: '[h]:mm:ss'},
  47: {f: 'mmss.0'},
  48: {f: '##0.0E+0'},
  49: {f: '@'},

  50: {
    'zh-tw': '[$-404]e/m/d',
    'zh-cn': 'yyyy"å¹´"m"æ"',
    'ja-jp': '[$-411]ge.m.d',
    'ko-kr': 'yyyy"å¹´" mm"æ" dd"æ¥"',
  },
  51: {
    'zh-tw': '[$-404]e"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': '[$-411]ggge"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'mm-dd',
  },
  52: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"',
    'zh-cn': 'yyyy"å¹´"m"æ"',
    'ja-jp': 'yyyy"å¹´"m"æ"',
    'ko-kr': 'yyyy-mm-dd',
  },
  53: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"ss"ç§"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': 'm"æ"d"æ¥"',
    'ko-kr': 'yyyy-mm-dd',
  },
  54: {
    'zh-tw': '[$-404]e"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': '[$-411]ggge"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'mm-dd',
  },
  55: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"',
    'zh-cn': 'ä¸å/ä¸å h"æ¶"mm"å"',
    'ja-jp': 'yyyy"å¹´"m"æ"',
    'ko-kr': 'yyyy-mm-dd',
  },
  56: {
    'zh-tw': 'ä¸å/ä¸å hh"æ"mm"å"ss"ç§"',
    'zh-cn': 'ä¸å/ä¸å h"æ¶"mm"å"ss"ç§"',
    'ja-jp': 'm"æ"d"æ¥"',
    'ko-kr': 'yyyy-mm-dd',
  },
  57: {
    'zh-tw': '[$-404]e/m/d',
    'zh-cn': 'yyyy"å¹´"m"æ"',
    'ja-jp': '[$-411]ge.m.d',
    'ko-kr': 'yyyy"å¹´" mm"æ" dd"æ¥"',
  },
  58: {
    'zh-tw': '[$-404]e"å¹´"m"æ"d"æ¥"',
    'zh-cn': 'm"æ"d"æ¥"',
    'ja-jp': '[$-411]ggge"å¹´"m"æ"d"æ¥"',
    'ko-kr': 'mm-dd',
  },

  59: {'th-th': 't0'},
  60: {'th-th': 't0.00'},
  61: {'th-th': 't#,##0'},
  62: {'th-th': 't#,##0.00'},
  67: {'th-th': 't0%'},
  68: {'th-th': 't0.00%'},
  69: {'th-th': 't# ?/?'},
  70: {'th-th': 't# ??/??'},

  81: {'th-th': 'd/m/bb'},
};
